import React from 'react';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { TitleCaptionText } from 'components/slices';
import { withStyles } from '@material-ui/styles';

const styles = {
  image: {
    maxWidth: '100%',
  },
};

function TextLeftImageRight(props) {
  const { data, classes } = props;
  return (
    <Container maxWidth={false}>
      <Grid container alignItems="center">
        <Grid item xs={12} md={6}>
          <Box px={[0, 2, 2, 16]}>
            <TitleCaptionText
              data={data}
              titlecomponent="h4"
              xs={12}
              md={12}
              lg={12}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <img
            className={classes.image}
            src={data.image.url}
            alt={data.image.alt}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

TextLeftImageRight.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TextLeftImageRight);
